/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDeliveryAreaRequest,
  GetDeliveryAreas200ResponseInner,
  GetStorefrontCheckoutConfig200Response,
  GetStorefrontCheckoutConfig200ResponseConfig,
  GetStorefrontConfig200Response,
  GetStorefrontConfig200ResponseConfig,
  UpdateDeliveryAreaRequest,
} from '../models/index';
import {
    CreateDeliveryAreaRequestFromJSON,
    CreateDeliveryAreaRequestToJSON,
    GetDeliveryAreas200ResponseInnerFromJSON,
    GetDeliveryAreas200ResponseInnerToJSON,
    GetStorefrontCheckoutConfig200ResponseFromJSON,
    GetStorefrontCheckoutConfig200ResponseToJSON,
    GetStorefrontCheckoutConfig200ResponseConfigFromJSON,
    GetStorefrontCheckoutConfig200ResponseConfigToJSON,
    GetStorefrontConfig200ResponseFromJSON,
    GetStorefrontConfig200ResponseToJSON,
    GetStorefrontConfig200ResponseConfigFromJSON,
    GetStorefrontConfig200ResponseConfigToJSON,
    UpdateDeliveryAreaRequestFromJSON,
    UpdateDeliveryAreaRequestToJSON,
} from '../models/index';

export interface CreateDeliveryAreaOperationRequest {
    createDeliveryAreaRequest: CreateDeliveryAreaRequest;
}

export interface DeleteDeliveryAreaRequest {
    areaId: string;
}

export interface UpdateDeliveryAreaOperationRequest {
    areaId: string;
    updateDeliveryAreaRequest?: UpdateDeliveryAreaRequest;
}

export interface UpdateStorefrontCheckoutConfigRequest {
    getStorefrontCheckoutConfig200ResponseConfig: GetStorefrontCheckoutConfig200ResponseConfig;
}

export interface UpdateStorefrontConfigRequest {
    getStorefrontConfig200ResponseConfig: GetStorefrontConfig200ResponseConfig;
}

/**
 * 
 */
export class StorefrontApi extends runtime.BaseAPI {

    /**
     */
    async createDeliveryAreaRaw(requestParameters: CreateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createDeliveryAreaRequest'] == null) {
            throw new runtime.RequiredError(
                'createDeliveryAreaRequest',
                'Required parameter "createDeliveryAreaRequest" was null or undefined when calling createDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/areas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDeliveryAreaRequestToJSON(requestParameters['createDeliveryAreaRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createDeliveryArea(requestParameters: CreateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createDeliveryAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteDeliveryAreaRaw(requestParameters: DeleteDeliveryAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling deleteDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/areas/{areaId}`.replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDeliveryArea(requestParameters: DeleteDeliveryAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeliveryAreaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDeliveryAreasRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetDeliveryAreas200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/areas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDeliveryAreas200ResponseInnerFromJSON));
    }

    /**
     */
    async getDeliveryAreas(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetDeliveryAreas200ResponseInner>> {
        const response = await this.getDeliveryAreasRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontCheckoutConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStorefrontCheckoutConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/checkout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStorefrontCheckoutConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getStorefrontCheckoutConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStorefrontCheckoutConfig200Response> {
        const response = await this.getStorefrontCheckoutConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getStorefrontConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStorefrontConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/storefront/config`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStorefrontConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getStorefrontConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStorefrontConfig200Response> {
        const response = await this.getStorefrontConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async updateDeliveryAreaRaw(requestParameters: UpdateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling updateDeliveryArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/areas/{areaId}`.replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDeliveryAreaRequestToJSON(requestParameters['updateDeliveryAreaRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateDeliveryArea(requestParameters: UpdateDeliveryAreaOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDeliveryAreaRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontCheckoutConfigRaw(requestParameters: UpdateStorefrontCheckoutConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getStorefrontCheckoutConfig200ResponseConfig'] == null) {
            throw new runtime.RequiredError(
                'getStorefrontCheckoutConfig200ResponseConfig',
                'Required parameter "getStorefrontCheckoutConfig200ResponseConfig" was null or undefined when calling updateStorefrontCheckoutConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/checkout`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetStorefrontCheckoutConfig200ResponseConfigToJSON(requestParameters['getStorefrontCheckoutConfig200ResponseConfig']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontCheckoutConfig(requestParameters: UpdateStorefrontCheckoutConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontCheckoutConfigRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateStorefrontConfigRaw(requestParameters: UpdateStorefrontConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getStorefrontConfig200ResponseConfig'] == null) {
            throw new runtime.RequiredError(
                'getStorefrontConfig200ResponseConfig',
                'Required parameter "getStorefrontConfig200ResponseConfig" was null or undefined when calling updateStorefrontConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/storefront/config`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetStorefrontConfig200ResponseConfigToJSON(requestParameters['getStorefrontConfig200ResponseConfig']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateStorefrontConfig(requestParameters: UpdateStorefrontConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStorefrontConfigRaw(requestParameters, initOverrides);
    }

}
